module.exports = __webpack_public_path__ + "media/performance/arrow-up-fec8fd5f.svg";